import { useUser } from "@/app/context/UserContext";
import { getcurrentUser } from "@/app/helpers/functions";
import { iActionRequest } from "@/app/models/interfaceChatBotAction";
import { chatbotSaveAction } from "@/app/services/chatbotsaveaction";
import { useState, useEffect, forwardRef, useRef } from "react"; // 🔹 NUEVO useRef

interface TextareaChatProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  onChangeValue?: (newValue: string) => void;
  actionCode: string;
  debounceDelay?: number;
}

const TextareaChat = forwardRef<HTMLTextAreaElement, TextareaChatProps>(
  ({ value = "", onChangeValue, actionCode, debounceDelay = 2000, ...props }, ref) => {
    const { user, userProject,accessType } = useUser();

    const [localValue, setLocalValue] = useState(value);
    const [isDirty, setIsDirty] = useState(false);
    const debounceRef = useRef<NodeJS.Timeout | null>(null);
    const [isSaving, setIsSaving] = useState(false); // 🔹 Nuevo: controla si ya se está guardando

    useEffect(() => {
      if (value !== localValue) setLocalValue(value);
    }, [value]);
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const val = e.target.value;
      setLocalValue(val);
      setIsDirty(true); // marca que hay cambios no guardados
      if (onChangeValue) onChangeValue(val);
      if (props.onChange) props.onChange(e);

      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        if (isDirty) saveAction(val);
      }, debounceDelay);
    };

    const handleBlur = () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
        debounceRef.current = null;
      }
      triggerSave(localValue.toString());
    };

    const triggerSave = (val: string) => {
      if (!isDirty || isSaving) return; // 🔹 Evita doble envío
      saveAction(val);
    };

    const saveAction = async (val: string) => {
      if (!user?.email) return;
      try {
        const data = props.name ? { [props.name]: val } : { value: val };
        const formObject = { target: "textarea", type: "textarea", data };
        const request: iActionRequest = {
          company_code: userProject?.project?.company_code ?? "",
          project_id: userProject?.project?.id ?? "",
          //user_id: user.email,
          user_id: getcurrentUser(accessType, userProject, user),
          action_code: actionCode,
          action_detail: formObject,
        };

        await chatbotSaveAction(request);
        setIsDirty(false);
      } catch (error) {
      } finally {
        setIsSaving(false);
      }
    };

    return (
      <textarea
        {...props}
        ref={ref}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    );
  }
);

TextareaChat.displayName = "TextareaChat";
export default TextareaChat;
